<!--
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
-->
<template>
  <div class="editor-box">
    <div class="toolbar">
      <span class="menu-item upload-menu" v-if="isShow">
        <upload
          :showFileList="false"
          accept="jpg,jpeg,png,txt,pdf,rar,xls,xlsx,ppt,pptx,zip,doc,docx,msg"
          :autoUpload="true"
          :on-success="success"
          maxFileSize="5MB"
          :on-error="handleAvatarError"
          :on-progress="handleProgress"
          :limit="10000"
          :beforeUpload="beforeUpload"
          :isChunk="true"
          :data = "{ clientType: 'purchaser' }"
        > 
          <img :src="syImgUrl+'162847544573851550.svg'"> <span class="upload-text">发送文件</span>
        </upload>
      </span>
    </div>
    <div class="textarea">
      <el-input
        type="textarea"
        placeholder="请输入内容"
        size="mini"
        maxlength="600"
        v-model="textarea"
        @keydown.enter.native="keyDown"
        resize="none"
        ></el-input>
    </div>
    <div class="editor-footer">
      <p class="tips">Shift + Enter 换行</p>
      <el-dropdown split-button type="primary" size="mini" @command="handleCommand" @click="handleSend">
        发送
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, key) in sendModeList" :command="key" :key="item">{{item.name}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<style scoped lang="scss">
.editor-box{
  height: 140px;
  box-sizing: border-box;
  padding: 12px 12px;
  border-top: 1px solid #EEEEEE;
  background: #fff;
}
.toolbar{
  margin-bottom: 10px;
  line-height: 20px;
  font-size: 12px;
}
.menu-item{
  cursor: pointer;
}
.upload-menu {
  padding: 0 5px;
  height: 20px;
  line-height: 20px;
  margin-left: -5px;
  display: inline-block;
  border-radius: 8px;
  img{
    vertical-align: middle;
  }
  .upload-text{
    vertical-align: middle;
  }
  &:hover{
    background: #F9F9F9;
  }
  ::v-deep .uploader{
    display: inline-block;
  }
}
.textarea{
  width: 100%;
  height: 40px;
  background: #ccc;
  ::v-deep .el-textarea__inner{
    font-size: 14px;
    height: 40px;
    padding: 0px 0;
    border: none;
  }
}
.editor-footer{
  padding-top: 4px;
  text-align: right;
  .tips{
    display: inline-block;
    color: #999A9D;
    font-size: 12px;
  }
  .send{
    background: #363E55;
    display: inline-block;
    line-height: 24px;
    color:  #fff;
    font-size: 12px;
    padding: 0 14px;
    border-radius: 5px;
    cursor: pointer;
  }
}
</style>

<script>
  import upload from '../../../basis/sy-upload/upload.vue'
  export default {
    props: {
      isShow: {
        type: false
      },
      activeMsgItem: {
        type: Object
      }
    },
    data () {
      return {
        textarea: '',
        sendMode: 'E', //  
        sendModeList: {
          E: {
            name: '按Enter发送'
          },
          CE: {
            name: '按Ctrl+Enter'
          }
        }
      }
    },
    components: {
      upload
    },
    methods: {
      handleCommand (command) {
        this.sendMode = command
      },
      sendMsg () {
        if (this.textarea !== '') {
          this.$emit('sendMsg', { msg: this.textarea, type: 'text' })
          this.textarea = ''
        } else {
          this.$message.error('消息不能为空')
        }
      },
      handleSend () {
        this.sendMsg()
        this.$nextTick(function () {
          this.textarea = ''
          this.$emit('scrollBottom')
        })
      },
      keyDown (e) {
        if (e.shiftKey  && e.keyCode === 13) {
          // console.log('换行')
          this.textarea += '\n'
        } else if (e.ctrlKey  && e.keyCode === 13) {
          if (this.sendMode === 'CE') {
            this.handleSend()
          }
          // console.log('ctrlKey enter')
        } else if (!e.altKey && !e.shiftKey && !e.ctrlKey) {
          if (this.sendMode === 'E') {
            this.handleSend()
          }
        }
        e.returnValue = false
        // if (e.ctrlKey && e.keyCode === 13) {   //用户点击了ctrl+enter触发
        //   
        // } else { //用户点击了enter触发
        //   this.sendMsg()
        //   this.$nextTick(function () {
        //     this.textarea = ''
        //     this.$emit('scrollBottom')
        //   })
        // }  
      },
      handleAvatarError (err, file) {
        console.log(err)
        let msgItem = this.activeMsgItem.msgList[this.findIndexMsgItem(file)]
        msgItem.msgBody.status = 'error'
      },
      handleProgress (percent, file) {
        let msgItem = this.activeMsgItem.msgList[this.findIndexMsgItem(file)]
        msgItem.msgBody.percent = percent.percent
        // console.log(JSON.stringify(percent), 'handleProgress')
        // console.log(file, msgItem)
      },
      findIndexMsgItem (file) {
        return this.activeMsgItem.msgList.findIndex(item => {
          return file.uid === item.msgBody.uid
        })
      },
      beforeUpload (file) {
        this.$emit('pretestMsg', {
          filePath: '',
          key: '',
          openUrl: '',
          originalName: file.name,
          uid: file.uid,
          id: file.id,
          percent: 0,
          status: 'send'
        })
      },
      removeMsg (file) {
        let index = this.findIndexMsgItem(file)
        // console.log(index)
        this.activeMsgItem.msgList.splice(index, 1)
      },
      success (res, file) {
        // console.log(res, file)
        this.removeMsg(file)
        this.$emit('sendMsg', { msg: res.content, type: 'file' })
      }
    }
  }
</script>